//@flow
import React from 'react';
import theme from 'common/entity/generic/ReadOnlyField.scss';
import Input from 'common/components/core/input';

type Props = {
    label: string,
    value: string
};
const ReadOnlyField = ({ label, value }: Props) => {
    return (
        <>
            <span className={theme.label}>{label}</span>
            <Input
                theme={theme}
                className={theme.input}
                value={value}
                disabled
            />
        </>
    );
};
export default ReadOnlyField;
